import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=64fcb42e&scoped=true"
import script from "./Copy.vue?vue&type=script&lang=js"
export * from "./Copy.vue?vue&type=script&lang=js"
import style0 from "./Copy.vue?vue&type=style&index=0&id=64fcb42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcb42e",
  null
  
)

export default component.exports